<template>
    <div>
        <ScreenAdapter>
            <div id="main">
                <Header :width="`1400`" />
                <Nav :width="`1400`" :height="`68`" />
                <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`">
                    <div class="banner-title">
                        聚焦入党积极分子与党员教育的核心需求，系统构建“入党必备”与“党性教育”两大知识体系。“入党必备”板块清晰梳理党员发展的标准要求与程序流程，确保学员对入党全环节了然于胸；“党性教育”板块则深入党的百年成就经验、性质宗旨、理念目标，精研党章党规，明晰党员权利义务，并特别针对新时代大学生党员，探讨如何践行合格党员标准，旨在通过理论学习与实践引导，全面提升学员的政治素养与党性修养，为培养担当民族复兴大任的时代新人奠定坚实思想基础。
                    </div>
                </div>
                <div class="eol-main-container">
                    <div class="rdbb-con">
                        <div class="categroy-title">入党必备</div>
                        <div class="rdbb-info">
                            <div class="info-lfet">
                                <div class="swiper">
                                    <swiper :options="swiperOption" v-if="theoryData.length > 0" ref="rdbbSwiper">
                                        <swiper-slide v-for="item in theoryData" :key="item.id"
                                            @click="jumpDetail(item)" :data-id="item.id">
                                            <div class="cover" :style="`background-image: url(${item.photo});`"
                                                :data-id="item.id"></div>
                                        </swiper-slide>

                                    </swiper>
                                    <div class="b swiper-button-next">
                                    </div>
                                    <div class="b swiper-button-prev">
                                    </div>
                                </div>
                                <div class="rdbb-page">
                                    <div class="page-item" @click="slideChange(i)" v-for="i in theoryData.length"
                                        :key="i" :class="{ active: swiperActive == i - 1 }">{{ i }}</div>
                                </div>

                            </div>
                            <div class="info-right">
                                <div class="info-link" @click="jumpDetail(theoryData[swiperActive])"
                                    v-if="theoryData.length > 0">
                                    <div class="info-title">{{ theoryData[swiperActive]?.name }} <div
                                            class="title-keywords">{{
                                                theoryData[swiperActive]?.category_name.split("-")[theoryData[swiperActive]?.category_name.split("-").length
                                                - 1] }}</div>
                                    </div>
                                    <div class="info-desc" v-html="decodeHtml(theoryData[swiperActive]?.intro)"></div>
                                </div>

                                <div class="info-list">
                                    <div class="info-item" :class="{ active: item.id == theoryData[swiperActive]?.id }"
                                        v-for="(item, ind) in theoryData" :key="item.id" @click="slideChange(ind + 1)">
                                        <div class="cover" :style="`background-image: url(${item.photo});`"></div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dxjy-con">
                        <div class="categroy-title">党性教育</div>
                        <div class="dxjy-list">
                            <div class="dxjy-item" v-for="item in historyData" :key="item.id" @click="jumpDetail(item)">
                                <div class="item-img">
                                    <div class="cover" :style="`background-image: url(${item.photo});`"></div>
                                </div>
                                <div class="item-title">
                                    <div class="hoverdir"></div>
                                    <div class="title-text">{{ item.name }}</div>
                                    <div class="subtit">{{
                                        item.category_name.split("-")[item.category_name.split("-").length - 1] }}</div>
                                </div>

                            </div>

                            <div class="dxjy-empty"></div>
                            <div class="dxjy-empty"></div>
                        </div>
                    </div>
                </div>
                <Footer />

            </div>
        </ScreenAdapter>
        <ToProgress></ToProgress>
    </div>


</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import ToProgress from "@/components/Hzvtc/to-progress.vue"
import services from '../../../config/services'
import ScreenAdapter from "../../../components/ScreenAdapter.vue"
import $ from 'jquery';
import "../../../assets/js/jquery.hoverdir.js"


export default {
    data() {
        let that = this
        return {
            cover: require("../../../assets/hzvtc/cover/zydx-banner.png"),
            school_code: services.HZ_CODE,
            swiperActive: 0,
            swiperOption: {
                loop: true,

                navigation: {
                    nextEl: ".swiper-button-next.b",
                    prevEl: ".swiper-button-prev.b",
                },

                on: {
                    slideChangeTransitionEnd() {
                        that.swiperActive = this.realIndex
                    },

                    click() {
                        const slide = this.clickedSlide
                        if (!slide) return

                        const id = slide.getAttribute("data-id")
                        window.open(`/center/${that.school_code}/hzvtc/newDetail?id=${id}&key=hzdx`, "_blank")
                    }
                }
            },

            theoryData: [], // 理论强党数据
            historyData: [], // 党史教育数据

        }
    },
    components: {
        Header,
        Nav,
        Footer,
        ScreenAdapter,
        ToProgress,
    },
    mounted() {
        this.getListData()


    },
    methods: {
        // currentActive (index) {
        //   this.swiperActive = index
        // },
        decodeHtml(html) {
            if (!html) return '';
            // 方法1：使用 DOMParser
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.documentElement.textContent;
        },
        setdxjyHover() {
            $(".dxjy-list .dxjy-item").each(function () {
                $(this).hoverdir();
            })

            $(".outContainer").on("scroll", function () {
                $(".dxjy-item").each(function () {
                    if ($(this).offset().top < window.innerHeight - 150) {
                        $(this).addClass("fade-in")
                    }
                })

            })
        },
        jumpPosition() {
            let that = this
            let position = that.$route.query.id
            if (position) {
                that.$nextTick(() => {
                    let topVal = this.$refs[position].getBoundingClientRect().top
                    let element = document.getElementsByClassName("outContainer")[0]
                    element.scrollTop = topVal - 100
                })
            }
        },
        async getListData() {
            // 入党必备
            await services.getCourseList({ page: 1, size: 2, category_id: "470", is_intro: "1", school_code: this.school_code }).then(res => {
                this.theoryData = res.data.items
            })
            // 党史教育
            await services.getCourseList({ page: 1, size: 100, category_id: "471", school_code: this.school_code }).then(res => {
                this.historyData = res.data.items
                this.$nextTick(() => {
                    this.setdxjyHover()
                })
            })
            // 锚点定位
            await this.jumpPosition()
        },
        jumpDetail(item) {
            // window.open(`/center/${this.school_code}/class/${item.id}`, "_blank")

            window.open(`/center/${this.school_code}/hzvtc/newDetail?id=${item.id}&key=hzdx`, "_blank")
        },
        slideChange(index) {
            this.swiperActive = index - 1
            this.$refs.rdbbSwiper.swiper.slideToLoop(index - 1)
        }
    },
}
</script>

<style lang="less" scoped>
#main {
    background: #fff;
    //  background-image: url(../../../assets/hzvtc/list/hzdx-bg.png);
}

.platform-cover {
    // background: rgb(204, 62, 62);
    width: 100%;
    height: 680px;
    background-size: cover;
    background-position: top center;
    padding-top: 342px;

    .banner-title {
        width: 1247px;
        margin: 0 auto;
        font-weight: 400;
        font-size: 16px;
        color: #646C71;
        line-height: 26px;
        text-align: center;
    }
}

.eol-main-container {
    width: 1400px;
    margin: 0 auto;
    padding: 34px 0 80px;

    .categroy-title {
        width: 1400px;
        margin: 0 auto;
        font-weight: bold;
        font-size: 42px;
        color: #B61E2A;
        background: linear-gradient(0deg, #B61E2A 0%, #EF350A 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        position: relative;

        &::after {
            width: 1400px;
            margin-top: 16px;
            height: 35px;
            content: "";
            display: block;
            background-image: url("../../../assets/hzvtc/list/hzdx-title.png");
            background-size: cover;
            background-position: center;
            // position: absolute;
        }


    }

    .rdbb-con {
        margin-top: -238px;

        .rdbb-info {
            height: 436px;
            margin-top: 30px;
            display: flex;

            .info-lfet {
                width: 776px;
                position: relative;

                .swiper {
                    height: 436px;

                    .swiper-container {
                        height: 100%;

                        .swiper-wrapper {
                            .swiper-slide {
                                // width: 100%;
                                background-color: #B61E2A;
                                overflow: hidden;
                                height: 100%;
                                cursor: pointer;

                                &:hover {
                                    .cover {
                                        transform: scale(1.1);
                                    }
                                }

                                .cover {
                                    width: 100%;
                                    height: 100%;
                                    background-size: cover;
                                    background-position: center;
                                    transition: all 0.3s;
                                }
                            }
                        }
                    }

                    .b.swiper-button-prev {
                        width: 44px;
                        height: 44px;
                        background: linear-gradient(0deg, #B61E2A 0%, #DF424E 100%);
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%) translateX(-50%);
                        z-index: 11;
                        left: 0;
                        cursor: pointer;

                        &:hover {
                            background: #B61E2A;
                        }

                        &::after {
                            width: 11px;
                            height: 24px;
                            content: "";
                            display: block;
                            background-image: url("../../../assets/hzvtc/list/hzdx-prev.png");
                            background-size: cover;
                            background-position: center;
                        }

                    }

                    .b.swiper-button-next {
                        width: 44px;
                        height: 44px;
                        background: linear-gradient(0deg, #B61E2A 0%, #DF424E 100%);
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%) translateX(50%);
                        z-index: 11;
                        right: 0;
                        cursor: pointer;

                        &:hover {
                            background: #B61E2A;
                        }

                        &::after {
                            width: 11px;
                            height: 24px;
                            content: "";
                            display: block;
                            background-image: url("../../../assets/hzvtc/list/hzdx-prev.png");
                            background-size: cover;
                            background-position: center;
                            transform: rotate(180deg);
                        }

                    }
                }

                .rdbb-page {
                    position: absolute;
                    bottom: 32px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    z-index: 11;

                    .page-item {
                        width: 32px;
                        height: 32px;
                        background: rgba(71, 8, 3, 0.5);
                        border-radius: 2px;
                        font-weight: bold;
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 32px;
                        width: 32px;
                        text-align: center;
                        margin: 0 6px;
                        cursor: pointer;

                        &.active {
                            background: #b61e2a;


                        }
                    }
                }
            }

            .info-right {
                height: 436px;
                background: linear-gradient(0deg, #FFFFFF 0%, #FDFAFA 66%, #FFF1D5 100%);
                border-radius: 4px;
                flex: 1;
                padding: 40px 56px 0;

                .info-link {
                    cursor: pointer;

                }

                .info-title {
                    font-weight: bold;
                    font-size: 24px;
                    color: #31302F;

                    .title-keywords {
                        height: 32px;
                        background: linear-gradient(90deg, #E7984C 0%, #F65C4B 100%);
                        border-radius: 4px;
                        display: inline-block;
                        white-space: nowrap;
                        font-weight: 400;
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 32px;
                        padding: 0 17px;
                        margin-left: 23px;
                    }
                }

                .info-desc {
                    font-weight: 400;
                    font-size: 16px;
                    color: #666666;
                    line-height: 32px;
                    height: 128px;
                    margin-top: 25px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 4;
                }

                .info-list {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 35px;

                    .info-item {
                        width: 240px;
                        height: 135px;
                        border-radius: 4px;
                        position: relative;
                        cursor: pointer;
                        overflow: hidden;

                        &.active {
                            &::after {
                                display: none;
                            }
                        }

                        &::after {
                            content: "";
                            display: block;
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            width: 100%;
                            height: 100%;
                            background-color: rgba(0, 0, 0, 0.4);
                        }

                        .cover {
                            width: 100%;
                            height: 100%;
                            background-size: cover;
                            background-position: center;
                            transition: all 0.3s;
                        }
                    }
                }
            }
        }

    }

    .dxjy-con {
        margin-top: 60px;

        .dxjy-list {
            display: flex;
            justify-content: space-between;
            margin-top: 32px;
            flex-wrap: wrap;

            .dxjy-item {
                width: 320px;
                margin-bottom: 40px;
                cursor: pointer;

                &:hover {
                    .item-img {
                        .cover {
                            transform: scale(1.1);
                        }
                    }

                    .item-title {
                        .title-text {
                            color: #fff;
                        }

                        .subtit {
                            color: #fff;
                        }
                    }

                }

                visibility: hidden;
                animation-delay: 0.1s;
                animation-name: none;

                &.fade-in {
                    visibility: visible;
                    animation-delay: 0.1s;
                    animation-name: fadeInUp;
                    -webkit-animation-duration: 0.8s;
                    animation-duration: 0.8s;
                    -webkit-animation-fill-mode: both;
                    animation-fill-mode: both;
                }



                .item-img {
                    width: 100%;
                    height: 180px;
                    border-radius: 4px 4px 0px 0px;
                    overflow: hidden;
                    position: relative;

                    .cover {
                        width: 100%;
                        height: 100%;
                        background-size: cover;
                        background-position: center;
                        transition: all 0.3s;
                    }
                }

                .item-title {
                    height: 113px;
                    background-color: #fff;
                    padding: 24px 24px 0;
                    position: relative;
                    overflow: hidden;
                    border: 1px solid #EDECE8;

                    .hoverdir {
                        position: absolute;
                        left: 100%;
                        width: calc(100% + 0.02rem);
                        height: 100%;
                        pointer-events: none;
                        background: #c01212;
                        border-radius: 0rem 0 0rem 0.14rem;
                        z-index: 0;
                    }

                    .title-text {
                        font-weight: bold;
                        font-size: 17px;
                        color: #31302F;
                        z-index: 1;
                        line-height: 20px;
                        position: relative;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .subtit {
                        font-weight: 400;
                        font-size: 14px;
                        color: #BC5D17;
                        line-height: 20px;
                        z-index: 1;
                        margin-top: 24px;
                        position: relative;
                    }
                }


            }

            .dxjy-empty {
                width: 320px;
            }
        }
    }

    .content-header {
        width: 100%;
        height: 42px;
        position: relative;
        z-index: 10;
    }

    .content-box {
        position: relative;
        z-index: 1;
    }

}

::v-deep .footer-container {
    margin-top: -50px;
}

.course-banner {
    display: block;
    width: 100%;
    height: 90px;
    margin: 20px 0 0;
    position: relative;
    z-index: 100;
}

@keyframes fadeInUp {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, 100%, 0);
        transform: translate3d(0, 100%, 0);
    }

    100% {
        opacity: 1;
        -webkit-transform: none;
        transform: none;
    }
}
</style>